import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=3f3a0127&scoped=true&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&id=3f3a0127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a0127",
  null
  
)

component.options.__file = "BaseOverlay.vue"
export default component.exports